import { ComponentType, SVGProps } from "react";
import styles from './Icon.module.css'

export enum IconTypes {
  EMPTY = 'empty',
  SOLID = 'solid'
}

export enum IconColors {
  LIGHT = 'light',
  DARK = 'dark'
}

interface IconProps extends React.HTMLAttributes<HTMLDivElement> {
  icon: ComponentType<SVGProps<SVGSVGElement>>,
  type?: IconTypes,
  color?: IconColors,
  stroke?: boolean
}

export default function Icon ({
  icon: IconComponent,
  className,
  type = IconTypes.EMPTY,
  color = IconColors.LIGHT,
  stroke = false,
  ...rest
}: IconProps) {

  return (
    <div className={`
      ${styles.container} 
      ${type ?? ''} 
      ${color ?? ''} 
      ${stroke ? styles.stroke : ''}
      ${className ?? ''}
    `} {...rest}>
      <IconComponent className={styles.icon} />
    </div>
  )
}